// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.resources-container {
  color: #333333;
  font-family: "AvenirNextLTW01-Regular", Arial;
}
.resources-container .sub-container {
  border-top: 1px solid #cccccc;
}
.resources-container ul {
  list-style-type: none;
  padding-left: 0;
  margin: 0;
}
.resources-container ul li {
  padding-bottom: 5px;
  padding-top: 5px;
  display: flex;
}
.resources-container ul li .arrow-wrapper {
  display: inline-block;
  overflow: hidden;
}
.resources-container ul li .pdf {
  margin: 0 5px;
}
.resources-container ul li a {
  font-family: "Avenir Next LT W01 Demi", Arial, sans-serif;
}
.resources-container ul li.divider-line-top {
  border-top: 1px solid #ccc;
}
.resources-container ul li.divider-line-bottom {
  border-bottom: 1px solid #ccc;
}
@media (max-width: 769px) {
.resources-container .row div:nth-child(2) {
    margin: 40px 0 0 0px;
    padding: 0;
}
}
`, "",{"version":3,"sources":["webpack://./src/components/SectionComponents/Resources.vue","webpack://./Resources.vue"],"names":[],"mappings":"AAGA;EACC,cAAA;EACA,6CAAA;ACFD;ADAA;EAKE,6BAAA;ACFF;ADHA;EASE,qBAAA;EACA,eAAA;EACA,SAAA;ACHF;ADRA;EAcG,mBAAA;EACA,gBAAA;EACA,aAAA;ACHH;ADbA;EAmBI,qBAAA;EACA,gBAAA;ACHJ;ADjBA;EAwBI,aAAA;ACJJ;ADpBA;EA4BI,yDAAA;ACLJ;ADQG;EACC,0BAAA;ACNJ;ADSG;EACC,6BAAA;ACPJ;ADYC;AAAA;IAGG,oBAAA;IACA,UAAA;ACXF;AACF","sourcesContent":["\n@import '~_css_/variables';\n\n.resources-container {\n\tcolor: @dark-gray;\n\tfont-family: @avenir-regular;\n\n\t.sub-container {\n\t\tborder-top: 1px solid @light-gray;\n\t}\n\n\tul {\n\t\tlist-style-type: none;\n\t\tpadding-left: 0;\n\t\tmargin: 0;\n\n\t\tli {\n\t\t\tpadding-bottom: 5px;\n\t\t\tpadding-top: 5px;\n\t\t\tdisplay: flex;\n\n\t\t\t.arrow-wrapper {\n\t\t\t\tdisplay: inline-block;\n\t\t\t\toverflow: hidden;\n\t\t\t}\n\n\t\t\t.pdf {\n\t\t\t\tmargin: 0 5px;\n\t\t\t}\n\n\t\t\ta {\n\t\t\t\tfont-family: @avenir-demi-sans;\n\t\t\t}\n\n\t\t\t&.divider-line-top {\n\t\t\t\tborder-top: 1px solid #ccc;\n\t\t\t}\n\n\t\t\t&.divider-line-bottom {\n\t\t\t\tborder-bottom: 1px solid #ccc;\n\t\t\t}\n\t\t}\n\t}\n\n\t@media (max-width: 769px) {\n\t\t.row {\n\t\t\tdiv:nth-child(2) {\n\t\t\t\tmargin: 40px 0 0 0px;\n\t\t\t\tpadding: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n",".resources-container {\n  color: #333333;\n  font-family: \"AvenirNextLTW01-Regular\", Arial;\n}\n.resources-container .sub-container {\n  border-top: 1px solid #cccccc;\n}\n.resources-container ul {\n  list-style-type: none;\n  padding-left: 0;\n  margin: 0;\n}\n.resources-container ul li {\n  padding-bottom: 5px;\n  padding-top: 5px;\n  display: flex;\n}\n.resources-container ul li .arrow-wrapper {\n  display: inline-block;\n  overflow: hidden;\n}\n.resources-container ul li .pdf {\n  margin: 0 5px;\n}\n.resources-container ul li a {\n  font-family: \"Avenir Next LT W01 Demi\", Arial, sans-serif;\n}\n.resources-container ul li.divider-line-top {\n  border-top: 1px solid #ccc;\n}\n.resources-container ul li.divider-line-bottom {\n  border-bottom: 1px solid #ccc;\n}\n@media (max-width: 769px) {\n  .resources-container .row div:nth-child(2) {\n    margin: 40px 0 0 0px;\n    padding: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
